module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/mother_and_daughter-e30b7d9127329a724bc3ad43cfb41e68.webp";